<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$store.state.theme.brand_color">
      <template v-if="$store.state.privilege && $store.state.privilege.mjd_management == true">
        <v-tab ripple :key="'Customer'" :href="'#Customer'">{{ 'Customer' }}</v-tab>
      </template>
      <v-tab ripple :key="'Appointment'" :href="'#Appointment'">{{ 'Appointment' }}</v-tab>
      <template v-if="$store.state.privilege && $store.state.privilege.mjd_management == true">
        <v-tab ripple :key="'Service'" :href="'#Service'">{{ 'Service' }}</v-tab>
      </template>
    </v-tabs>
    <div v-if="currentView">
      <component :is="currentView"></component>
    </div>
  </div>
</template>

<script>
import Appointment from './Appointment.vue'
import Customer from './Customer.vue'
import Service from './Service.vue'
export default {
  data() {
    return {
      currentView: 'Customer'
    }
  },
  components: {
    Appointment,
    Customer,
    Service
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      if (this.$store.state.privilege && this.$store.state.privilege.mjd_management == true) {
        vm.currentView = 'Customer'
      } else {
        vm.currentView = 'Appointment'
      }
    }
  },
  async mounted() {},
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/main.vue